<ng-container *ngIf="config">
  <app-tabs (currentTabChange)="onChangeTab($event)" [(currentTab)]="config.currentTab" [tabs]="config.tabs"></app-tabs>
  <div *ngFor="let tab of config.tabs" [hidden]="tab.key !== config.currentTab.key" class="table-container display">
    <table [id]="config.tableConfig.baseTableIdPrefix + tab.key" class="display"></table>
  </div>
</ng-container>
